import error from "actions/error";
import includes from "lodash/includes";

const actionsToIgnore = [
  "COMPANY_PUBLIC_GET_REJECTED",
  "PORTFOLIOS_PUBLIC_GET_REJECTED",
  "CONTACTS_PUBLIC_GET_REJECTED",
  "USER_LOGIN_LINKEDIN_REJECTED",
];

export const errorMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (action.type.endsWith("_REJECTED") && !includes(actionsToIgnore, action.type)) {
      dispatch(error(action.payload));

      return next(action);
    }

    return next(action);
  };

export default errorMiddleware;
